'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDayjs;
function getDayjs() {
  var dayjs = global.dayjs;

  if (!dayjs) {
    throw new Error('Dayjs is required in global variable');
  }
  return dayjs;
}